<h5>
  Filters
  @if (formFields.primaryForm && additionalFilters.length > 0) {
    <span class="pull-right search-button-container">
      <button
        type="button"
        mat-stroked-button
        class="search-button"
        [matMenuTriggerFor]="moreFiltersMenu"
      >
        <mat-icon class="me-2">filter_alt</mat-icon> More Filters
      </button>
      @if (moreFilterCount() > 0) {
        <span class="filter-counter">{{ moreFilterCount() }}</span>
      }
    </span>

    <mat-menu #moreFiltersMenu="matMenu" direction="down" yPosition="below">
      @for (filter of additionalFilters; track filter.varName) {
        <app-grid-filter-fields
          class="w-100"
          [currentFilters]="currentFilters"
          [groupKey]="'primaryForm'"
          [filterForm]="filterForm"
          [field]="filter"
          [gridName]="gridName"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          (textChange)="textChange($event, filter)"
          (valueRangeChange)="valueRangeChange($event, filter)"
          (dateChange)="dateChange($event, filter)"
          (selectionChange)="selectionChange($event, filter)"
          (clearFilter)="clearFilter($event, filter, 'primaryForm')"
          (additionalData)="handleAdditionalData($event)"
        />
      }
    </mat-menu>
  }
</h5>
@if (
  filterForm &&
  (filterForm.controls.primaryForm || filterForm.controls.secondaryForm)
) {
  <form [formGroup]="filterForm">
    @for (group of formFields | keyvalue; track group.key) {
      @if (group.key === 'primaryForm' || group.key === 'secondaryForm') {
        <div
          formGroupName="{{ group.key }}"
          [ngClass]="{
            'case-search-advanced-filter-container':
              (gridName === 'CaseSearch' || gridName === 'CopyCase') &&
              group.key === 'secondaryForm',
            'hide-secondary':
              (gridName === 'CaseSearch' || gridName === 'CopyCase') &&
              group.key === 'secondaryForm' &&
              !advancedFilters,
          }"
        >
          @for (field of group.value; track field.varName) {
            @if (!field.conditionalParent && !field.conditionalField) {
              <app-grid-filter-fields
                [currentFilters]="currentFilters"
                [groupKey]="group.key"
                [filterForm]="filterForm"
                [field]="field"
                [gridName]="gridName"
                (textChange)="textChange($event, field)"
                (valueRangeChange)="valueRangeChange($event, field)"
                (dateChange)="dateChange($event, field)"
                (relatedDateChange)="relatedDateChange($event, field)"
                (selectionChange)="selectionChange($event, field)"
                (clearFilter)="clearFilter($event, field, group.key)"
                (additionalData)="handleAdditionalData($event)"
              />
            }
          }

          @if (hasConditionalFields(group.value)) {
            <div>
              @for (field of group.value; track field.varName) {
                @if (field.conditionalParent) {
                  <app-grid-filter-fields
                    [currentFilters]="currentFilters"
                    [groupKey]="group.key"
                    [filterForm]="filterForm"
                    [field]="field"
                    [gridName]="gridName"
                    (textChange)="textChange($event, field)"
                    (valueRangeChange)="valueRangeChange($event, field)"
                    (dateChange)="dateChange($event, field)"
                    (relatedDateChange)="relatedDateChange($event, field)"
                    (selectionChange)="selectionChange($event, field)"
                    (clearFilter)="clearFilter($event, field, group.key)"
                    (additionalData)="handleAdditionalData($event)"
                  />

                  @for (
                    conditionalField of group.value;
                    track conditionalField.varName
                  ) {
                    @if (
                      !conditionalField.conditionalParent &&
                      conditionalField?.conditionalField === field.varName
                    ) {
                      <app-grid-filter-fields
                        [currentFilters]="currentFilters"
                        [groupKey]="group.key"
                        [filterForm]="filterForm"
                        [field]="conditionalField"
                        [gridName]="gridName"
                        (textChange)="textChange($event, conditionalField)"
                        (valueRangeChange)="
                          valueRangeChange($event, conditionalField)
                        "
                        (dateChange)="dateChange($event, conditionalField)"
                        (relatedDateChange)="
                          relatedDateChange($event, conditionalField)
                        "
                        (selectionChange)="
                          selectionChange($event, conditionalField)
                        "
                        (clearFilter)="
                          clearFilter($event, conditionalField, group.key)
                        "
                        (additionalData)="handleAdditionalData($event)"
                      />
                    }
                  }
                }
              }
            </div>
          }

          @if (
            (gridName === 'CaseSearch' || gridName === 'CopyCase') &&
            showSearchButton(group.key)
          ) {
            <button
              type="button"
              matButton="elevated"
              color="primary"
              class="search-button ml-2"
              [disabled]="disableSearch"
              (click)="triggerManualSearch()"
            >
              <mat-icon class="mr-2">search</mat-icon>
              {{ searchButtonText || 'Search Results' }}
            </button>
            <mat-checkbox
              class="invert-color ml-2"
              color="primary"
              [checked]="advancedFilters"
              (change)="toggleAdvancedFilters($event)"
            >
              Advanced Search
            </mat-checkbox>
            @if (
              globals &&
              globals.user.managerUnitCount &&
              globals.user.managerUnitCount > 0
            ) {
              <span class="ml-1 hierarchy-tooltip">
                <mat-icon
                  #tooltip="matTooltip"
                  matTooltip="If you don't see the cases you are looking for, search based on a specific User or Rep Code. Unit will be ignored if User is entered. Unit and User will be ignored if Rep Code is entered."
                  aria-label="Icon that displays a tooltip regarding advanced search and hierarchy filter prioritization"
                >
                  help
                </mat-icon>
              </span>
            }
          } @else {
            @if (showSearchButton(group.key)) {
              <button
                type="button"
                matButton="elevated"
                color="primary"
                class="search-button ml-2"
                [disabled]="disableSearch || cstmFltrSrvc.hashingStatus()"
                (click)="triggerManualSearch()"
              >
                <mat-icon class="mr-2">search</mat-icon>
                @if (cstmFltrSrvc.hashingStatus()) {
                  Updating Filters...
                } @else {
                  {{ searchButtonText || 'Search Results' }}
                }
              </button>
            }
          }
        </div>
      }
    }
    @if (showFilterManager) {
      <app-manage-filters
        [grid]="gridName"
        [defaultEmptyGrid]="defaultEmptyGrid"
        [currentFormFields]="formFields"
        [currentForm]="filterForm"
        [currentFilters]="currentFilters"
        [selectedTemplateVar]="selectedTemplateVar"
        [additionalFilters]="additionalFilters"
        [hiddenCols]="hiddenCols"
        [colSort]="colSort"
        [colOrder]="colOrder"
        (selectedTemplate)="applySavedFilters($event, true)"
        (hiddenColsEmitter)="applyHiddenCols($event)"
        (colSortEmitter)="applyColSort($event)"
        (colOrderEmitter)="applyColOrder($event)"
      />
    }
  </form>
}
